import { cn } from '@/lib/utils';
import { Tab as HeadlessTab } from '@headlessui/react';
import React from 'react';

const Tabs = HeadlessTab.Group;

const TabsList = React.forwardRef(({ className, ...props }, ref) => (
  <HeadlessTab.List
    ref={ref}
    className={cn(
      'bg-muted inline-flex items-center justify-center gap-2 rounded-md p-1',
      className,
    )}
    {...props}
  />
));
TabsList.displayName = HeadlessTab.List.displayName;

const Tab = React.forwardRef(({ className, ...props }, ref) => (
  <HeadlessTab
    ref={ref}
    className={({ selected }) =>
      cn(
        'w-max border-b-2 border-b-transparent px-4 py-2.5 text-center text-20 font-medium leading-5',
        'ring-offset-0 focus:outline-none focus:ring-0',
        selected
          ? ' border-b-secondary text-text-primary'
          : 'text-text-secondary',
        className,
      )
    }
    {...props}
  />
));
Tab.displayName = HeadlessTab.displayName;

const TabPanels = React.forwardRef(({ className, ...props }, ref) => (
  <HeadlessTab.Panels ref={ref} className={className} {...props} />
));
TabPanels.displayName = HeadlessTab.Panels.displayName;

const TabPanel = React.forwardRef(({ className, ...props }, ref) => (
  <HeadlessTab.Panel ref={ref} className={className} {...props} />
));
TabPanel.displayName = HeadlessTab.Panel.displayName;

export { Tabs, TabsList, Tab, TabPanels, TabPanel };
